import {Component, Vue} from 'vue-facing-decorator';
import { ref } from "vue";
import Loading from 'vue-loading-overlay';
import Antrian from '@/components/Antrian/Antrian.vue';

import ax from '@/utils/axios_geneng';

import { useConfirm } from "primevue/useconfirm";

@Component({
    name: 'daftar-view',
    components: {       
        'loading'    : Loading,
        'antrian'    : Antrian
    }
})
export default class DaftarView extends Vue{
    confirm         = useConfirm();

    isLoading       = false;
    isLodingSyarat  = true;
    isIklan         = false;

    errors :any = ref({})
    success:any = false
    error  :any = false
    //-------------------------------------------------------------
    get syarat_jenis() {
        return this.$store.state.syaratJenis;
    }
    
    //-------------------------------------------------------------
    posisi = 1;

    //area-01
    syarat : any        = ref([]) //syarat dan jenis
    jenis  : any        = ''
    
    //area-02
    no_rm   : any       = ref('')
    no_bpjs : any       = ref('')
    data_pasien : any   = ref({}) //data pasien dan poli

    //area-03
    date_range : any    = ref([])
    selectedPoli: any   = ref() //poli yang terpilih
    selectedDate: any   = ref() //tanggal yang terpilih
    selectedDokter: any = ref() //tanggal yang terpilih

    wajib_kontrol:any   = false
    kontrol: any        = ''
    no_tlp: any         = ''

    //area-04
    antrian:any         = ref()
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    mounted(){
        //this.getSyarat();
        if(this.syarat_jenis){
            this.isLodingSyarat = false;
        }else{
            this.getSyaratJenis()
        }

        if(!this.syarat_jenis.syarat){
            this.posisi = 2;
        }
    }
    //-------------------------------------------------------------


    //=================================================================================================
    //AREA - 01
    //=================================================================================================
    //-------------------------------------------------------------
    async getSyaratJenis(){
        this.isLodingSyarat = true
        await ax.get('get_persyaratan_jenis')
        .then((res) => {
            this.isLodingSyarat = false;
            if(res.data.status){
                this.$store.dispatch('syaratJenis/setSyaratJenis', res.data.data);
            }else{
                this.$toast.add({ severity: 'warn',  summary: 'Failed', detail: res.data.message, life: 3000 });
            }
        })
        .catch ((err) => {
            this.isLodingSyarat = false;
            this.$toast.add({ severity: 'warn',  summary: 'Failed', detail: err.message, life: 3000 });
            if(err.response){
                this.$toast.add({ severity: 'error',  summary: err.message, detail: err.response.data.message, life: 3000 });
            }
        })
    }
    //-------------------------------------------------------------
    pilihJenis(jenis :any){
        this.jenis = jenis;
        console.log(this.jenis)
        this.lanjut();
    }
    //-------------------------------------------------------------
    //=================================================================================================





    //=================================================================================================
    //AREA - 02
    //=================================================================================================
    //-------------------------------------------------------------
    toFour(){
        if(!this.no_rm){
            this.$toast.add({ severity: 'warn',  summary: 'Data Pasien', detail: "Nomor RM Wajib Diisi!! Silahkan Isi terlebih dahulu", life: 4000 });
        }

        if(this.jenis.type == 'TUNAI'){
            if(this.no_rm){
                this.getPoli();
            }
        }else if(this.jenis.type == 'BPJS'){
            if(!this.no_bpjs){
                this.$toast.add({ severity: 'warn',  summary: 'Data Pasien', detail: "Nomor BPJS/KIS/NIK Wajib Diisi!! Silahkan Isi terlebih dahulu", life: 4000 });
            }
            else if(this.no_rm && this.no_bpjs.length == 13 || this.no_bpjs.length == 16){
                this.getPoli();
            }else{
                this.$toast.add({ severity: 'warn',  summary: 'Data Pasien', detail: "Nomor BPJS/KIS harus 13 digit atau NIK/KTP harus 16 digit!! Silahkan Isi dengan benar", life: 4000 });
            }
        }
    }
    //-------------------------------------------------------------
    backTwo(){
        this.no_rm          = '';
        this.no_bpjs        = '';
        this.data_pasien    = ref();
        this.kembali();
    }
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    async getPoli(){
        this.isLoading = true;
        this.errors    = ref({})
        this.error     = ""
        const url      = 'area2/get_poli';

        await ax.post(url, {
            "id_jenis"  : this.jenis.id,
            "no_rm"     : this.no_rm,
            "no_bpjs"   : this.no_bpjs
        }).then((res : any ) => {
            this.isLoading = false;
            if(res.data.status){
                this.data_pasien = res.data.data;
                this.lanjut();
            }else{
                this.errors = res.data.errors
                this.confirm.require({
                    group: 'headless',
                    message: res.data.message,
                    header: 'Info',
                });
            }
            //console.log(res);
        }).catch((err : any) => {
            this.isLoading = false;
            this.$toast.add({ severity: 'error',  summary: 'Error', detail: err.message, life: 6000 });
            if(err.response){
                this.error = err.response.data.message
                this.confirm.require({
                    group: 'headless',
                    message: err.response.data.message,
                    header: 'Info',
                });
                if(err.response.data.errors){
                    this.errors = err.response.data.errors
                }
            }
            console.log(err)
        })
    }
    //-------------------------------------------------------------
    //=================================================================================================





    //=================================================================================================
    //AREA - 03
    //=================================================================================================

    //POLI
    //-------------------------------------------------------------
    changePoli(event : any){
        //console.log(event.value)
        if(event.value){
            //console.log(event.value)
            this.getDate(event.value.id);
        }
        this.date_range   = ref([])
        this.selectedDate = ref()
        this.selectedDokter = ref()
    }
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    changeDate(){
        this.errors     = ref({})
        this.error      = ""
        this.selectedDokter = ref()
        //console.log(event.value)
    }
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    async getDate(id_poli : any){
        this.errors     = ref({})
        this.error      = ""
        this.isLoading  = true;
        const url       = 'area3/get_date';
    
        await ax.post(url, {
            no_rm    : this.no_rm,
            id_jenis : this.jenis.id,
            id_poli  : id_poli
        }).then((res : any ) => {
            this.isLoading = false;
            if(res.data.status){
                this.wajib_kontrol  = res.data.data.wajib_kontrol;
                this.date_range     = res.data.data.date_range;
                //console.log(res.data.data)
            }else{
                this.errors = res.data.errors
                this.confirm.require({
                    group: 'headless',
                    message: res.data.message,
                    header: 'Info',
                });
                this.selectedPoli = ref()
            }
            //console.log(res);
        }).catch((err : any) => {
            this.isLoading = false;
            this.selectedPoli = ref()
            this.$toast.add({ severity: 'error',  summary: 'Error', detail: err.message, life: 6000 });
            if(err.response){
                this.error = err.response.data.message
                this.confirm.require({
                    group: 'headless',
                    message: err.response.data.message,
                    header: 'Info',
                });
                if(err.response.data.errors){
                    this.errors = err.response.data.errors
                }
            }
            //console.log(err)
        })
    }
    //-------------------------------------------------------------


    //DOKTER
    //-------------------------------------------------------------
    changeDokter(){
        this.errors     = ref({})
        this.error      = ""
        //console.log(event.value)
    }
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    backTree(){
        this.selectedPoli   = ref();
        this.data_pasien    = ref();

        this.selectedDate   = ref();
        this.date_range     = ref([]);
        
        this.no_tlp         = "";
        this.wajib_kontrol  = false;
        this.kontrol        = "";
        this.kembali();
    }
    //-------------------------------------------------------------
    //=================================================================================================
    
    


    //=================================================================================================
    //AREA - 04
    //=================================================================================================
    //-------------------------------------------------------------
    kirim(){
        this.errors = {};

        if(!this.selectedPoli){
            this.errors.poli = 'Silahkan pilih terlebih dahulu Poli yang anda tuju!!';
            this.$toast.add({ severity: 'warn',  summary: 'Peringantan', detail: "Silahkan pilih terlebih dahulu Poli yang anda tuju!!", life: 4000 });
        }

        if(!this.selectedDate){
            this.errors.tanggal = 'Silahkan pilih terlebih dahulu Tanggal pemeriksaan anda!!';
            this.$toast.add({ severity: 'warn',  summary: 'Peringantan', detail: "Silahkan pilih terlebih dahulu Tanggal pemeriksaan anda!!", life: 4000 });
        }

        if(this.wajib_kontrol && !this.kontrol){
            this.errors.kontrol = 'Silahkan isi terlebih dahulu nomor surat kontrol anda!!';
            this.$toast.add({ severity: 'warn',  summary: 'Peringantan', detail: "Silahkan isi terlebih dahusu nomor surat kontrol!!", life: 4000 });
        }

        if (this.selectedPoli && this.selectedDate && (this.wajib_kontrol ? this.kontrol : true)) {
            this.getAntrian()
        }
        
    }
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    backHome(){
        this.posisi         = 1
        if(!this.syarat_jenis.syarat){
            this.posisi = 2;
        }
        this.error = ""
        this.errors = ref({})

        this.selectedDate   = ref();
        this.selectedPoli   = ref();
        this.data_pasien    = ref();
        this.date_range     = ref([]);

        this.no_rm          = '';
        this.no_bpjs        = '';

        this.no_tlp         = "";
        this.wajib_kontrol  = false;
        this.kontrol        = "";
        this.antrian        = ref()
    }
    //-------------------------------------------------------------

    //-------------------------------------------------------------
    async getAntrian(){
        this.error = '';

        this.isLoading = true;
        const url  = 'area4/get_antrian';
    
        await ax.post(url, {
            no_rm               : this.no_rm,
            id_jenis            : this.jenis.id,
            id_poli             : this.selectedPoli.id,
            tanggal             : this.selectedDate.tgl,
            no_bpjs             : this.no_bpjs,
            no_surat_kontrol    : this.kontrol,
            no_rujukan          : this.selectedPoli.rujukan ? this.selectedPoli.rujukan.no_rujukan : "",
            no_tlp              : this.no_tlp,
            id_dokter           : this.selectedDokter ? this.selectedDokter.id : '',
        }).then((res : any ) => {
            this.isLoading = false;
            //console.log('ok-------------------------------------')
          
                if(res.data.status){
                    this.antrian = res.data.data;
                    this.lanjut();
                }else{
                    this.error = res.data.message;
                    this.confirm.require({
                        group: 'headless',
                        message: res.data.message,
                        header: 'Info',
                    });
                }
            //console.log(res.data.log);
            console.log(res.data)
        }).catch((err : any) => {
            //console.log('error-------------------------------------')
            this.isLoading = false;
            this.error = err.message;
            this.confirm.require({
                group: 'headless',
                message: err.message,
                header: 'Info',
            });
            console.log(err)
        })
    }
    //-------------------------------------------------------------

    //=================================================================================================
    
    
    
    
    //-------------------------------------------------------------
    lanjut(){
        this.error = ""
        this.errors = ref({})
        if(this.posisi >= 5){
            this.posisi = 5;
        }else{
            this.posisi += 1;
        }
    }
    //-------------------------------------------------------------
    kembali(){
        this.error = ""
        this.errors = ref({})
        if(this.posisi == 1){
            this.posisi = 1;
        }else{
            this.posisi -= 1;
        }
    }
    
    //-------------------------------------------------------------


    //-------------------------------------------------------------
    async getSyarat(){
        this.isLodingSyarat = true;
        await ax.get('/get/syarat/online/rajal').then((res : any ) => {
            //console.log(res.data)
            if(res.data.status){
                this.syarat = res.data.data;
            }else{
                this.syarat = this.$store.state.syarat.list;
            }
            this.isLodingSyarat = false;
        }).catch(() => {
            this.isLodingSyarat = false;
            //console.log(err.message)
        })
    }
    //-------------------------------------------------------------



    //-------------------------------------------------------------
    formatDate(dateString: string): string {
        try {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            return `${(day < 10 ? '0' : '') + day}-${(month < 10 ? '0' : '') + month}-${year}`;
        }catch (error : any) {
            console.error('Error formatting date:', error.message);
            return dateString;
        }
    }
    //-------------------------------------------------------------


}